import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from 'react-intl-universal';
import { withRouter, Link } from 'react-router-dom';
import Immutable from 'immutable';
import classNames from 'classnames';
import Doyle from '@jianshu/doyle';
import styles from './HistoryContentContainer.scss';
import { NoteHistory } from '../../constants/actionTypes';
import { getNoteHistoryContent, restoreNoteHistoryContent } from '../../actions/NoteHistoryAction';
import { getNoteHistoryState } from '../../reducers/NoteHistory/NoteHistoryReducer';
import message from '../../components/Message';
import formatDate from '../../utils/formatDate';
import NestLoading from '../../components/Loading/NestLoading';
import Icon from '../../components/Icon/Icon';
import { formatTheVideoPackage } from '../../utils/util';

const doyle = new Doyle();

@withRouter
@connect(
  state => ({
    noteHistory: getNoteHistoryState(state),
  }),
  dispatch => ({
    getNoteHistoryContent: (historyId, noteId) => {
      dispatch(getNoteHistoryContent(historyId, noteId));
    },
    restoreNoteHistoryContent: (nbId, noteId, historyId) => {
      dispatch(restoreNoteHistoryContent(nbId, noteId, historyId));
    },
  }),
)
export default class HistoryContentContainer extends Component {
  state = {
    loading: false,
    isRevertBtnLoading: false,
  };

  componentWillMount() {
    const { match } = this.props;
    const { params: { historyId, noteId } } = match;
    if (historyId) {
      this.props.getNoteHistoryContent(historyId, noteId);
    }
    // 首次挂载时需要
    this.setState({
      loading: true,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { noteHistory, history, match } = nextProps;
    const { params: { historyId: nextHistoryId, nbId, noteId } } = match;
    const curHistoryId = this.props.match.params.historyId;
    // 获取content
    if (nextHistoryId !== curHistoryId) {
      this.props.getNoteHistoryContent(nextHistoryId, noteId);
    }

    const getContentsStatus = noteHistory.getIn(['contents', 'status']); // 获取内容的action状态
    const restoreStatus = noteHistory.getIn(['restore', 'status']); // 恢复版本的action状态
    this.setState({
      loading: getContentsStatus === NoteHistory.GET_NOTE_HISTORY_CONTENT,
      isRevertBtnLoading: restoreStatus === NoteHistory.RESTORE_NOTE_HISTORY_CONTENT,
    });

    // 成功恢复时
    if (restoreStatus === NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_SUCCESS) {
      history.push(`/notebooks/${nbId}/notes/${noteId}/`);
    }
    // 恢复失败时需要提示
    if (restoreStatus === NoteHistory.RESTORE_NOTE_HISTORY_CONTENT_FAIL) {
      message.error('error.try-again');
    }
  }

  componentDidUpdate() {
    if (this.noteWrapElem) {
      formatTheVideoPackage(this.noteWrapElem);
    }
  }

  revertBtnClick = () => {
    const { match } = this.props;
    const { params: { nbId, noteId, historyId } } = match;
    const { isRevertBtnLoading } = this.state;
    if (isRevertBtnLoading || !historyId) {
      return;
    } // 正在请求后端恢复版本
    this.setState({
      isRevertBtnLoading: true,
    });
    this.props.restoreNoteHistoryContent(nbId, noteId, historyId); // send action
  };

  getNoteType = () => {
    const { match, noteHistory } = this.props;
    const { params: { historyId } } = match;
    const historyItem = noteHistory.get('list').find((v) => {
      return `${v.get('id')}` === `${historyId}`;
    }) || Immutable.fromJS({});
    return historyItem.get('note_type');
  };

  getContentHTML = () => {
    const { match, noteHistory } = this.props;
    const { params: { historyId } } = match;
    const noteType = this.getNoteType();
    const content = noteHistory.getIn(['contents', 'entities', historyId, 'content'], '');
    // 2 --> markdown
    if (noteType === 2) {
      return doyle.parse(content);
    }
    return content;
  };

  render() {
    const { match, noteHistory } = this.props;
    const { params: { nbId, noteId, historyId } } = match;
    const {
      loading,
      isRevertBtnLoading,
    } = this.state;
    const noteList = noteHistory.getIn(['list'], Immutable.fromJS([])).toJS();
    const noteContentItem = noteHistory.getIn(['contents', 'entities', historyId], Immutable.fromJS({})).toJS();
    const noteTitle = noteContentItem.title || '';
    const noteListItem = noteList.filter(v => v.id === noteContentItem.id)[0];
    let updatedAt = '';
    if (noteListItem) {
      updatedAt = formatDate(new Date((noteListItem.updated_at) * 1000), 'yyyy-MM-dd hh:mm');
    }
    const contentHTML = this.getContentHTML();
    const revertBtnClasses = classNames(styles['revert-btn'], {
      [styles['revert-btn__loading']]: isRevertBtnLoading,
    });
    return (
      <div className={styles['history-view']}>
        <div className={styles['revision-top']}>
          <h3>
            {noteTitle}
          </h3>
          <span className={styles['time-tag']}>
            {updatedAt}
          </span>
          {
            !isRevertBtnLoading &&
            <Link className={styles['close']} to={`/notebooks/${nbId}/notes/${noteId}/`}>×</Link>
          }
          <span className={revertBtnClasses} onClick={this.revertBtnClick}>
            {i18n.get('history.recovery-to')}
            <Icon name='spinner' spin/>
          </span>
        </div>
        <div className={styles['view-area-wrap']}>
          <div
            className={classNames('note-view', styles['note-view'])}
            dangerouslySetInnerHTML={{ __html: contentHTML }}
            ref={
              (v) => {
                this.noteWrapElem = v;
              }
            }
          />
          <NestLoading loading={loading} hasMask/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/HistoryContentContainer/HistoryContentContainer.js